import { TmdxAvatar, Tooltip } from '@ds';

type HeaderCardProps = {
  label: string;
  image?: string;
  code?: string;
  state?: string;
};

const HeaderCard = ({ label, image, code, state }: HeaderCardProps) => (
  <div className="bg-base-60 p-2 rounded-xl max-w-48 w-48">
    <div className="flex flex-row items-center gap-2">
      <TmdxAvatar size="md" radius="md" name={code || state} fallbackInitials={false} type="facility" src={image} />
      <div className="truncate">
        <Tooltip className="text-m-r!" content={label} showArrow>
          <div className="text-m-m truncate">{label}</div>
        </Tooltip>
      </div>
    </div>
  </div>
);

export default HeaderCard;
